import { Component, computed, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ListRolesFacade } from '../../../../../Facades/list-roles.facade';
import { Role } from '../../../../../Models/avyna/role.model';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvTableLoadingBarComponent } from '../../../../Shared/Components/loading-bar/table-loading-bar.component';
import { AuthService } from '../../../../Shared/Services/auth.service';
import { MsgService } from '../../../../Shared/Services/msg.service';
import { RolesService } from '../../../../../Services/roles.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { firstValueFrom } from 'rxjs';
import { PERMISSIONS } from '../../../../../Enums/permission.enum';

@Component({
  selector: 'app-roles-table',
  imports: [COMMON_IMPORTS, AvTableLoadingBarComponent],
  templateUrl: './roles-table.component.html',
  styleUrls: [
    './roles-table.component.scss',
    '../../../../../../assets/theme/cutom/_av-table.scss',
  ],
})
export class RolesTableComponent {
  readonly facade = inject(ListRolesFacade);
  private _authService = inject(AuthService);
  private _msgService = inject(MsgService);
  private _rolesService = inject(RolesService);

  currentUser = toSignal(this._authService.currentUser$, { initialValue: null });
  permissions = PERMISSIONS;

  readonly displayedColumns: string[] = [
    'index',
    'name',
    'intune_group',
    'permissions',
    'created_date',
  ];

  ngOnInit() {
    this.initActionColumn();
  }

  private initActionColumn(): void {
    if (this.currentUser()?.hasPermission(this.permissions.ROLE_EDIT) || this.currentUser()?.hasPermission(this.permissions.ROLE_DELETE)) {
      this.displayedColumns.push('action');
    }
  }

  readonly roles = computed<Role[]>(() => this.facade.roles());

  readonly dataSource = computed(() => {
    return new MatTableDataSource<Role>(this.roles());
  });

  onPageChange(event: PageEvent): void {
    this.facade.setPage(event.pageIndex);
  }

  onSortChange(sort: Sort): void {
    this.facade.setSort(sort.active, sort.direction);
  }

  permissionList(role: Role): string {
    return role.permissions?.map((permission) => permission.name).join(', ') ?? '';
  }

  async confirmAndDeleteRole(role: Role): Promise<void> {
    const confirmed = await this._msgService
      .showConfirm(
        'app.settings.role_management.form.delete_confirm_title',
        'app.settings.role_management.form.delete_confirm_message',
        '',
        'delete',
        'error',
      )
      .afterClosed()
      .toPromise();
    if (!confirmed || !role.id) return;

    try {
      await firstValueFrom(this._rolesService.delete(role.id));
      this.facade.reload();
    } catch (error: any) {
      this._msgService.showSnackBar(error?.error?.message ?? 'shared.general.errors.default', { type: 'error' });
    }
  }
}
